module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("Cover Design: "), _c('a', {
    attrs: {
      "href": "http://www.written-ink.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Written Ink Designs")])]), _vm._v(" | written-ink.com")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Image(s) used under a Standard Royalty-Free License.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("WARNING: This book is not transferable. It is for your own personal use. If it is sold, shared, or given away, it is an infringement of the copyright of this work and violators will be prosecuted to the fullest extent of the law.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("No portion of this book may be transmitted or reproduced in any form, or by any means, without permission in writing from the publisher, with the exception of brief excerpts used for the purposes of review.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("This book is for ADULT AUDIENCES ONLY. It may contain sexually explicit scenes and graphic language which might be considered offensive by some readers. Please store your files where they cannot be accessed by minors.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("This is a work of fiction. Names, characters, places, and incidents are solely the product of the author’s imagination and/or are used fictitiously, though reference may be made to actual historical events or existing locations. Any resemblance to actual persons, living or dead, is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Published in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Watching Cars Go By")]), _vm._v(" would still be sitting in a parking lot were it not for the invaluable input of several wonderfully patient friends who generously invested their time and energy in reading our manuscript through various stages of development.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("On the American side, proofreader extraordinaire, Carolyn Bottomley, painstakingly went over every inch of the first draft, a much longer version than the final, and didn’t miss a single comma, quotation mark, or even the errant extra space here and there. Her input and suggestions held us up to her own very high standards, all done for the price of a few cat-themed T-shirts! We also benefitted from her advice as a professional consultant when questions arose related to biomedical technology.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Beta reader Kassandra Salazar not only liked our story; she made sure we used all Hispanic terms correctly and appropriately to the situation. Across the ocean, beta reader Maria Ware did the same for all German words, and Klaus Kirchgatterer, a fan of all we write, inspired and motivated us to keep things moving when our own motivation lagged.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Much gratitude goes to our children, Alayne and John Fronimos and Justin Lakey, for being supportive and lending a helping hand every time the computer stumped us in some form or another.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("And a special thanks to a very special lady, Mini Gaugenrieder, for all her love and encouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("We are also very grateful to JMS Books for taking a chance on us and this manuscript, and we’re thankful for all their help in navigating the convoluted road to publishing.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t2"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d45bd66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003.vue
// module id = 60
// module chunks = 0